import { Card, Col, Divider, Row, Space, Button } from "antd";
import { Info } from "components/elements";

import { currencyFormatter } from "utils/formatter";
import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";

function address2String(address = {}, lang = "en") {
  const {
    subdistrict = {},
    district = {},
    province = {},
    zipCode = null,
  } = address;

  let text = `${[
    address.address,
    lang === "en" ? subdistrict?.subDistrictNameEn : subdistrict?.subDistrictName,
    lang === "en" ? district?.districtNameEn : district?.districtName,
    lang === "en" ? province?.provinceNameEn : province?.provinceName,
  ]
    .filter((n) => n)
    .join(", ")} ${zipCode || ""}`.trim();

  return text.length > 0 ? text : "-";
}

const CompanyBranchView = ({
  currentBranch = {},
  onCancel = () => { },
  onEdit = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <Space className={styles.container} direction="vertical" size={24}>
      <Row justify="end" className={styles.container}>
        <Button onClick={onCancel} type="default" style={{ height: "40px", borderRadius: "8px" }}>
          {t("common.back")}
        </Button>
        {/* <Button type="default" className={styles.buttom} onClick={onEdit}>
          {t("common.edit")}
        </Button> */}
      </Row>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("branch.label.branch_information")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Info
              label={t("branch.label.branch_id")}
              value={currentBranch.branchCode}
            />
          </Col>
          <Col span={12}>
          </Col>
          <Col span={12}>
            <Info
              label={t("branch.label.name_th")}
              value={currentBranch.branchName}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("branch.label.name_en")}
              value={currentBranch.branchNameEn}
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("branch.label.branch_address_information")}
        </b>
        <Divider />
        <Row gutter={[0, 16]}>
          <Info
            label={t("branch.label.address_th")}
            value={address2String(currentBranch, "th")}
          />
          <Info
            label={t("branch.label.address_en")}
            value={address2String(currentBranch)}
          />
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("branch.label.compensation_rate")}
        </b>
        <Divider />
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <Info
              label={t("branch.label.bank_account_no")}
              value={currentBranch.bankAccountNo}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("branch.label.business_code")}
              value={currentBranch.businessCode}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("branch.label.insurance_contribution")}
              value={
                currentBranch.insurancePersonRate
                  ? `${currencyFormatter(
                    currentBranch.insurancePersonRate,
                    2,
                    ""
                  )} %`
                  : "-"
              }
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("branch.label.salary_not_over")}
              value={
                currentBranch.salaryNotOver
                  ? `${currencyFormatter(
                    currentBranch.salaryNotOver,
                    2,
                    ""
                  )} ${t("unit.baht")}`
                  : "-"
              }
            />
          </Col>
        </Row>
      </Card>
    </Space>
  );
};

export default CompanyBranchView;
